/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated';
import { concatDependencies } from './dependenciesConcat.generated';
import { setIntersectDependencies } from './dependenciesSetIntersect.generated';
import { setSymDifferenceDependencies } from './dependenciesSetSymDifference.generated';
import { sizeDependencies } from './dependenciesSize.generated';
import { subsetDependencies } from './dependenciesSubset.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSetUnion } from '../../factoriesAny.js';
export var setUnionDependencies = {
  IndexDependencies: IndexDependencies,
  concatDependencies: concatDependencies,
  setIntersectDependencies: setIntersectDependencies,
  setSymDifferenceDependencies: setSymDifferenceDependencies,
  sizeDependencies: sizeDependencies,
  subsetDependencies: subsetDependencies,
  typedDependencies: typedDependencies,
  createSetUnion: createSetUnion
};